import { render } from "./TextPoll.vue?vue&type=template&id=57f64b7a"
import script from "./TextPoll.vue?vue&type=script&lang=js"
export * from "./TextPoll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__